<ng-template #confirmAddressModal let-modal>
    <div class="modal fade show d-block" tabindex="-1" role="dialog" stytle="gap:20px">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content" style="gap: 20px;">
                <div class="modal-header" style="border-bottom: 1px solid #DEDEDE;">
                    <h5 class="modal-title">Thông tin xuất hóa đơn</h5>
                    <button type="button" class="d-flex align-items-center justify-content-center"
                        style="background-color: var(--theme-color); border: none; color: white; width: 32px; height: 32px; border-radius: 5px; font-size: 24px;"
                        (click)="modal.close(null)">
                        <i class="ri-close-line"></i>
                    </button>
                </div>

                <div style="font-size: 16px; color: #707070; line-height: 120%; padding: 0 24px;">
                    DV MedKing - Giathuoctot.com sẽ xuất hóa đơn theo thông tin sau:
                </div>

                <div class="d-grid"
                    style="border: 1px solid #0000000F; border-radius: 6px; gap: 24px; margin: 0 24px 0 24px;">
                    <div style="padding: 16px;">
                        <div class="d-flex flex-column" style="gap: 12px;">
                            <div class="d-flex label-item flex-column">
                                <div class="invoice-label">Họ tên người mua hàng</div>
                                <div class="invoice-value">{{ user.buyerName }}</div>
                            </div>
                            <div class="d-flex label-item flex-column">
                                <div class="invoice-label">Tên đơn vị</div>
                                <div class="invoice-value">{{ user.businessName }}</div>
                            </div>
                            <div class="d-flex label-item flex-column">
                                <div class="invoice-label">Mã số thuế</div>
                                <div class="invoice-value">{{ user.taxNumber }}</div>
                            </div>
                            <div class="d-flex label-item flex-column">
                                <div class="invoice-label">Địa chỉ</div>
                                <div class="invoice-value">{{ user.address?.address }}, {{
                                    user.address?.provinceV2?.wards?.[0]?.name }}, {{
                                    user.address?.provinceV2?.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="font-size: 16px; color: #707070; line-height: 120%; padding: 0 24px;">
                    Nếu cần cập nhật thông tin, đơn hàng sẽ được tiếp nhận và nhân viên CSKH sẽ liên hệ với Quý khách để
                    hỗ trợ ngay.
                </div>

                <div class="d-flex px-4" style="gap: 20px; justify-content: space-between; margin-bottom: 20px;">
                    <button type="submit" class="border-0 btn-back-desktop"
                        style="color: #202020; background-color: #0000000A; border-radius: 6px; min-width: 120px; height: 40px; font-size: 16px;"
                        (click)="modal.close(null)">
                        Quay lại
                    </button>
                    <div class="d-flex div-mb-view" style="gap: 20px">
                        <button type="submit" class="bt-mb-view"
                            style="color: var(--theme-color); background-color: #FFFFFF; border-radius: 6px; border: 1px solid var(--theme-color); min-width: 120px; height: 40px; font-size: 16px;"
                            (click)="modal.close(true)">
                            Cần cập nhật
                        </button>
                        <button type="submit" class="border-0 bt-mb-view"
                            style="color:#FFFFFF; background-color: var(--theme-color); border-radius: 6px; min-width: 120px; height: 40px; font-size: 16px;"
                            (click)="modal.dismiss('no-changes-needed')">
                            Đồng ý
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</ng-template>